






































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { keyTree, ifExitKey, types, typeKey } from "../template";
const TemplateRead = () => import("./template-read.vue");
import ReadJianyanzu from "./read-jianyanzu.vue";
import ReadTable from "./read-table.vue";
@Component({
  components: {
    TemplateRead,
    ReadJianyanzu,
    ReadTable,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifErji: any;
  @Watch("ifErji", { immediate: true })
  private ifErjiChange() {
    this.getTypes();
  }
  @Prop({ type: Boolean, default: true })
  private showBtn: any;
  @Prop({ type: Array, default: [] })
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.$forceUpdate();
    }
  }
  @Prop()
  private ifEdit: any;
  private types: any = [];
  private getTypes() {
    let arr: any = [];
    // 二级有些控件不支持嵌套
    if (this.ifErji) {
      types().forEach((ele: any) => {
        if (
          ele != "目录式多选" &&
          ele != "压痛点" &&
          ele != "中药饮片信息" &&
          ele != "其它用药信息" &&
          ele != "动态数组" &&
          ele != "检验组" &&
          ele != "表格"
        ) {
          arr.push(ele);
        }
      });
    } else {
      arr = types();
    }
    this.types = arr;
  }
  private getTypeKeys(type: any) {
    let arr: any = [];
    const strArr: any = typeKey(type);
    if (strArr && strArr.length > 0) {
      strArr.forEach((ele: any) => {
        // id不能编辑,二级编辑，二级嵌套和逻辑控制不能用
        if (this.ifErji) {
          if (
            ele != "id" &&
            ele != "sub_title" &&
            ele != "extra" &&
            ele != "hide" &&
            ele != "control" &&
            ele != "basic"
          ) {
            arr.push(keyTree(ele));
          }
        } else {
          if (ele != "id") {
            arr.push(keyTree(ele));
          }
        }
      });
    }
    return arr;
  }
  private editWenti(d: any) {
    this.$emit("changeEdit", d);
  }
  private getMarkData(d: any) {
    let arr: any = [];
    for (const key in d) {
      if (Object.prototype.hasOwnProperty.call(d, key)) {
        const element = d[key];
        const obj = {
          name: Number(key),
          value: element,
        };
        arr.push(obj);
      }
    }
    return arr;
  }
  private updata(e: any, key: any, id: any) {
    let d = JSON.parse(JSON.stringify(this.data));
    let i: any = 0;
    d.forEach((ele: any, index: any) => {
      if (ele.id == id) {
        i = index;
      }
    });
    d[i][key] = e;
    this.$emit("updateData", d);
  }
  private delWenti(d: any) {
    this.$confirm("您是否确定删除当前题目？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      let i: any = "";
      this.data.forEach((ele: any, index: any) => {
        if (ele.id == d.id) {
          i = index;
        }
      });
      this.$emit("changeDel", i);
    });
  }
  private ifExitKey(type: any, key: any) {
    return ifExitKey(type, key);
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private allowDrag() {
    if (this.ifEdit) {
      return true;
    } else {
      return false;
    }
  }
  private nodeDrop() {
    this.$emit("updateData", this.data);
  }
  /**
   * @description 选择题目
   */
  private changeSelect(e: any, item: any) {
    item.checked = e;
    this.$forceUpdate();
    this.$emit("updateData", this.data);
  }
}
